import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);
export default {
    data() {
        return {
            title: '',
            hashTitle: '',
            categoryTitle: '',
            categorySequence: 0,
            themeTitle: '',
            hashtag: [],
            content1: '',
            // p_display : 1,
            p_reserve_date: '',
            magazinCategory: '',
            item1: {},
            editorIdx: 1,
            p_url:'',
            category: '',

            magazineTitle:'', // 광고매거진 제목
            magazineNo : '', // 광고 매거진 번호
            DateRange : [], // 광고 매거진 노출 기간
            exposureDateStart : '', // 광고 매거진 노출 시작일
            exposureDateEnd : '', // 광고 매거진 노출 종료일

            mainFile: [], //메인 이미지
            themeDisplay: 0, //테마 노출
        }
    },
    validators: {
        p_reserve_date: function (value) {
            let msg = '날짜를 선택해주세요.'
            return Validator.value(value)
                .required(msg)
                .minLength(1, msg)
                .custom(
                    () => {
                        var today = new Date();
                        let valueDate = new Date(value);
                        var year = valueDate.getFullYear();
                        var month = ('0' + (valueDate.getMonth() + 1)).slice(-2);
                        var day = ('0' + valueDate.getDate()).slice(-2);
                        var hours = ('0' + valueDate.getHours()).slice(-2);
                        var minutes = ('0' + valueDate.getMinutes()).slice(-2);
                        var seconds = ('0' + valueDate.getSeconds()).slice(-2);
                        var check = (today.getTime() < valueDate.getTime());
                        if (value === null || value === '') {
                            return msg;
                        } else if (!check) {
                            msg = '오늘 이후로 입력됩니다.';
                            value = valueDate;
                            day = value.getDate() + 1;
                            var dateString = year + '-' + month + '-' + day + ' ' +  hours + ':' + minutes + ':' + seconds;
                            this.p_reserve_date = dateString;
                            return msg;
                        }

                    })
        },
        title: function (value) {
            let msg = '1~12자 내로 입력해주세요.';
            return Validator.value(value)
                .required('제목을 입력해주세요.')
                // .minLength(1, msg)
                // .maxLength(12, msg)
        },
        themeTitle: function (value) {
            return Validator.value(value)
                .required('제목을 입력해주세요.');
        },
        hashtag: function (value) {
            let msg = '';
            return Validator.value(value)
                .custom(
                    () => {
                        if (value.length < 1) {
                            msg = '해시태그를 선택해 주세요.';
                            return msg;
                        } else if (value.length > 5) {
                            msg = '해시태그는 최대 5개까지 등록할 수 있습니다.';
                            value.length = 5;
                            return msg;
                        }
                    })
        },
        categoryTitle: function (value) {
            let msg = '1 ~ 20자로 입력해주세요.';
            return Validator.value(value)
                .required('제목을 입력해주세요.')
                .minLength(1, msg)
                .maxLength(20, msg)
        },
        hashTitle: function (value) {
            let msg = '1 ~ 8자로 입력해주세요.';
            return Validator.value(value)
                .required('제목을 입력해주세요.')
                // .minLength(1, msg)
                .maxLength(8, msg)
               /* .custom(
                    () => {
                        let regex = value.replace(/[^ㄱ-ㅎ|ㅏ-ㅣ|가-힣|]*$/,'');
                        this.hashTitle = regex;
                    }
                )*/
        },
        content1: function (value) {
            return Validator.value(value)
                .required('내용을 입력해주세요.')
                .custom(
                    () => {
                        let content = value.replace(/<(\/p|br|p)([^>]*)>/gi,"");
                        if(content.length === 0) {
                            return '내용을 입력해주세요.'
                        }
                    }
                )
        },
        item1: function(value) {
            return Validator.value(value)
                .required('상품을 선택해주세요.');
        },
        p_url: function (value) {
            return Validator.value(value)
                .required('URL을 입력해주세요.');
        },
        category: function (value) {
            return Validator.value(value)
                .required('카테고리를 선택해주세요.')
        },
        magazineTitle : function (value) {
            return Validator.value(value)
                .required('제목을 입력해주세요.');
        },
        magazineNo : function (value) {
            return Validator.value(value)
                .required('매거진 번호를 입력해주세요.');
        },
        DateRange: function (value) {
            return Validator.value(value)
                .required('기간을 선택해주세요.')
        },
        exposureDateStart:  function (value) {
            return Validator.value(value)
        },
        exposureDateEnd :  function (value) {
            return Validator.value(value)
        },
        themeDisplay : function (value) {
            return Validator.value(value)
        },
        categorySequence: function (value) {
            return Validator.value(value)
                .required('순서를 입력해주세요.')
                .integer('숫자만 입력 가능합니다.')
        },
    },
    methods: {
    },
    computed: {
    }
}
